interface SectionHeadingProps {
  description?: string;
  eyebrow: string;
  id: string;
  title?: string;
}

export const SectionHeading = ({
  description,
  eyebrow,
  id,
  title,
}: SectionHeadingProps) => (
  <div className="mb-8 max-w-2xl md:mb-10">
    <p className="font-semibold text-[#8a6d2f] text-xs uppercase tracking-[0.18em]">
      {eyebrow}
    </p>
    {title && (
      <h2
        className="mt-2 font-bold text-2xl text-[#051124] tracking-tight md:text-3xl"
        id={id}
      >
        {title}
      </h2>
    )}
    {description && (
      <p className="mt-3 text-base text-gray-600">{description}</p>
    )}
  </div>
);
